import { useAtom } from "jotai";

import { sampleAtom } from "../store/sample";

export const useSample = () => {
  const [sample, sampleSet] = useAtom(sampleAtom);

  return { sample, sampleSet };
};